import { urlUtils } from '../../utils/url';
import { fetchLabels } from '../../services/content';
import {
  logSearch,
  logProductImpression,
} from '../../utils/logUtils/CruiseListLogUtils';
import {
  fetchCruises,
  fetchCruisesForInspiration,
} from '../../services/cruise';
import * as ACTIONS from '../actionTypes/cruiseListActionTypes';

const initSuccess = (labels, data, siteSettings) => {
  urlUtils.updateUrlWithSessionId(data.result.serviceCallInformation.sessionId);
  return (dispatch) => {
    dispatch({
      type: ACTIONS.INIT_SUCCESS,
      labels,
      cruises: data.result.packages,
      filter: data.result.filterOptions,
      preSelectedFilter: siteSettings.filter,
      searchInformation: data.result.searchInformation,
    });
  };
};

export const toggleErrorPopup = (error) => {
  return {
    type: ACTIONS.TOGGLE_ERROR_POPUP,
    ...error,
  };
};

const initFail = (labels) => {
  return {
    type: ACTIONS.INIT_FAIL,
    labels,
  };
};

const initFinished = (labels, data, siteSettings) => {
  return (dispatch) => {
    const { packages, loggingData } = data?.result;
    if (packages && packages.length > 0) {
      dispatch(initSuccess(labels, data, siteSettings));
      logProductImpression(packages);
    } else {
      dispatch(initFail(labels));
    }

    if (loggingData) {
      logSearch(loggingData, data?.translatedMessage);
    }

    dispatch({
      type: ACTIONS.INIT_FINISHED,
    });
  };
};

const getLabels = async (siteSettings) => {
  const labels = await fetchLabels(siteSettings, 'iwCruiseList');
  const { general, ...rest } = labels;
  return {
    ...rest,
    ...general,
  };
};

const getCruises = async (siteSettings, userId) => {
  const { isInspiration } = siteSettings;
  if (isInspiration) {
    return fetchCruisesForInspiration(siteSettings, userId);
  }
  return fetchCruises(siteSettings, userId);
};

const addMessage = (message) => {
  return {
    type: ACTIONS.ADD_MESSAGE,
    message,
  };
};

const cruiseInitError = () => {
  return (dispatch) => {
    dispatch({
      type: ACTIONS.INIT_FINISHED,
    });
    dispatch(
      addMessage({
        title: 'An error occurred, please redo your search.',
        severity: 'ERROR',
      }),
    );
  };
};

export const init = () => {
  return async (dispatch, getState) => {
    const { siteSettings, userId } = getState().toJS().common;

    try {
      const [labels, cruisesResult] = await Promise.all([
        getLabels(siteSettings),
        getCruises(siteSettings, userId),
      ]);

      // If cruise search failed, show error message
      if (cruisesResult.statusCode !== 200) {
        console.log(`Cruise search error: ${cruisesResult.errorMessage}`);
        dispatch(
          addMessage({
            title: labels
              ? labels.iwErrors?.systemError?.heading
              : 'An error occurred, please redo your search.',
            severity: 'ERROR',
          }),
        );
      }

      // Show translatedMessage from API
      if (cruisesResult.translatedMessage) {
        dispatch(addMessage(cruisesResult.translatedMessage));
      }

      dispatch(initFinished(labels, cruisesResult, siteSettings));
    } catch (error) {
      // If unexpected error occurred, show error message.
      console.log(`Unexpected error in cruise init: ${error}`);
      dispatch(cruiseInitError());
    }
  };
};

export const sortCruiseList = (sortBy) => {
  return {
    type: ACTIONS.SORT_CRUISE_LIST,
    sortBy,
  };
};

export const toggleSortPanel = (isVisible) => {
  return {
    type: ACTIONS.TOGGLE_SORT_PANEL,
    isVisible,
  };
};

export const toggleFilterPanel = (isVisible) => {
  return {
    type: ACTIONS.TOGGLE_FILTER_PANEL,
    isVisible,
  };
};

export const selectFilterDepartureMonth = (selectedId) => {
  return {
    type: ACTIONS.SELECT_FILTER_DEPARTURE_MONTH,
    selectedId,
  };
};

export const selectFilterShipRating = (rating) => {
  return {
    type: ACTIONS.SELECT_FILTER_SHIP_RATING,
    rating,
  };
};

export const selectFilterDuration = (lowValue, highValue) => {
  return {
    type: ACTIONS.SELECT_FILTER_DURATION,
    lowValue,
    highValue,
  };
};

export const selectFilterCruiseCategory = (selectedId) => {
  return {
    type: ACTIONS.SELECT_FILTER_CRUISE_CATEGORY,
    selectedId,
  };
};

export const selectFilterDestination = (selectedId) => {
  return {
    type: ACTIONS.SELECT_FILTER_DESTINATION,
    selectedId,
  };
};

export const selectFilterNumberOfDestinations = (lowValue, highValue) => {
  return {
    type: ACTIONS.SELECT_FILTER_NUMBER_OF_DESTINATIONS,
    lowValue,
    highValue,
  };
};

export const selectFilterShippingCompany = (selectedId) => {
  return {
    type: ACTIONS.SELECT_FILTER_SHIPPING_COMPANY,
    selectedId,
  };
};

export const clearSingleFilter = (filterGroupKey) => {
  return {
    type: ACTIONS.CLEAR_SINGLE_FILTER,
    filterGroupKey,
  };
};

export const clearFilters = () => {
  return {
    type: ACTIONS.CLEAR_FILTERS,
  };
};
